import React, {useEffect, useRef, useState} from "react";
import {FormattedMessage} from "react-intl";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import Switch from '@mui/material/Switch';
import FormControlLabel from '@mui/material/FormControlLabel';
import Popper from "@mui/material/Popper";
import Grow from "@mui/material/Grow";

import {useIsMounted} from "../../../../misc/helperHooks";
import {featureInterface} from "../../../../interfaces/featureInterface";
import {IS_PRODUCT_JOURNEY} from "../../../../config";


let timeoutId = null;

const LookAllWallsRadioButtonSmall = (props) => {

  const {allWallsCheckboxClick, translateId, checked, viewType, lookActiveCategory, showTutorialToolTip, isMobile,
    lookFeature} = props;

  const [showTooltip, setShowTooltip] = useState(false);
  const anchorRef = useRef(null);
  const isMounted = useIsMounted();

  useEffect(() => {
    return () => clearTimeout(timeoutId);
  }, []);

  useEffect(() => {
    if (showTutorialToolTip) {
      timeoutId = setTimeout(() => {
        if (isMounted()) {
          setShowTooltip(true);
        }
      }, 0);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isMounted, showTutorialToolTip]);

  const buttonClick = () => {
    setShowTooltip(true);
    clearTimeout(timeoutId);
    allWallsCheckboxClick();
    timeoutId = setTimeout(() => {
      if (isMounted()) {
        setShowTooltip(false);
      }
    }, 2000);
  }

  const placement = viewType !== 1 || showTutorialToolTip
    ? isMobile && IS_PRODUCT_JOURNEY ? "left" : "right"
    : "bottom";

  const getToolTipTranslate = () => {
    if (!showTutorialToolTip) {
      return translateId
    }
    switch (lookFeature ? lookFeature.partId : lookActiveCategory) {
      case "countertop":
      case "center_island_countertop":
      case "vanity_countertop":
        return "look.allWallsOverlay.countertop.text"
      case "backsplash":
      case "vanity_backsplash":
        return "look.allWallsOverlay.backsplash.text"
      case "top_cabinet":
      case "bottom_cabinet":
      case "center_island_cabinet":
      case "fridge_enclosure":
        return "look.allWallsOverlay.cabinet.text"
      case "edge":
      case "edge_profile":
      case "center_island_edge":
        return "look.allWallsOverlay.edge.text"
      default:
        return "look.allWallsOverlay.text"
    }
  }

  return (
    <div className="gm-ios-checkbox-small-wrapper" ref={anchorRef}>
      <FormControlLabel
        label={null}
        control={
          <Switch
            checked={checked}
            className={"gm-ios-checkbox gm-ios-checkbox--small"}
            disableRipple
            onChange={buttonClick}
            color="primary"
          />
        }
      />
      <Popper open={showTooltip}
              className={"look-all-walls-tooltip look-all-walls-tooltip--" + placement
                + (showTutorialToolTip ? " look-all-walls-tooltip--tutorial" : "")}
              anchorEl={anchorRef.current}
              placement={placement}
              transition
              disablePortal={showTutorialToolTip}>
        {({ TransitionProps }) => (
          <Grow
            {...TransitionProps}
            style={{ transformOrigin: placement === "bottom" ? "left bottom" : "right center" }}
          >
            <div className="look-step__content">
              <span className={"look-step__content-text look-step__content-text--white look-step__content-text--" + placement}>
                <FormattedMessage id={getToolTipTranslate()}/>
                <span className="yellow">: <FormattedMessage id={checked ? "radioButton.on" : "radioButton.off"}/></span>
              </span>
            </div>
          </Grow>
        )}
      </Popper>
    </div>
  )
};

LookAllWallsRadioButtonSmall.propTypes = {
  translateId: PropTypes.string,
  checked: PropTypes.bool.isRequired,
  allWallsCheckboxClick: PropTypes.func.isRequired,
  viewType: PropTypes.number,
  showTutorialToolTip: PropTypes.bool,
  lookFeature: PropTypes.shape(featureInterface),
}

const mapStateToProps = (store) => {
  const {lookActiveCategory} = store.lookState;
  const {isMobile} = store.serverState;
  return {
    lookActiveCategory,
    isMobile,
  };
};

export default (
  connect(mapStateToProps)(LookAllWallsRadioButtonSmall)
)
